import { AvailableService } from '../services/Appointment/model';

export const getService = (
  serviceId: string,
  services: AvailableService[] = [],
): AvailableService | undefined => {
  const currentService = services.find(
    (s: AvailableService): boolean => s.serviceId === serviceId,
  );

  return currentService;
};

export const serviceDescriptions = (
  t: (x: string, y?: object) => string,
  serviceId: string,
): string => {
  const infoTextKey = `services.infoText.${serviceId}`;
  const fallbackKey = `services.description.${serviceId}`;
  const infoTextTranslation = t(infoTextKey);
  const fallbackTranslation = t(fallbackKey);

  if (infoTextTranslation && infoTextTranslation !== infoTextKey) {
    return infoTextTranslation;
  }
  if (fallbackTranslation && fallbackTranslation !== fallbackKey) {
    return fallbackTranslation;
  }
  return '';
};
